module.exports = __webpack_public_path__ + "static/media/recovery-logos.7ba2a40b.png";